































import {Component, ModelSync, Prop, Vue} from 'vue-property-decorator'
import BoolSelect from "@/component/Select/bool-select.vue";

@Component({
  components: {BoolSelect}
})
export default class BoolColumn extends Vue {
  @Prop()
  prop!: string

  @ModelSync('value', 'change')
  readonly valueSync?: boolean

  @Prop({default: undefined})
  search?: (() => {})

  @Prop({default: undefined})
  header?: string

  @Prop({default: '是'})
  trueText!: string

  @Prop({default: '否'})
  falseText!: string

  @Prop({default: ''})
  activeColor!: string

  @Prop({default: 'normal'})
  size!: string

  @Prop({default: false})
  clearable!: boolean

  private getHeader() {
    return this.header ?? this.prop
  }

  private onChange() {
    if (this.search != undefined)
      this.search()
  }
}
